<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <div class="main-container" style="padding: 15px; margin: 5px;">
    <!-- Keep main static header -->
    <div class="main-heading">
      <h1>Important Updates</h1>
    </div>

    <!-- Data table -->
    <div class="card" style="max-width:100%;">

      <div class="header-row">
        <!-- LEFT: dynamic inline heading (changes with dropdown and BE bucket) -->
        <div class="inline-source-title">
          <h2 class="sub-heading">
            <!-- Use computedSourceTitle if you added it; otherwise fallback to inline expression -->
            {{ (computedSourceTitle || (selectedSource === 'updatedbeguidance'
            ? (sourceTitleMap[selectedSource] + (beBucket === 'newly_revised' ? ' - Newly Revised' : ' - Newly Added'))
            : sourceTitleMap[selectedSource])) }}
          </h2>
        </div>

        <!-- RIGHT: controls -->
        <div class="right-controls">
          <button class="btn btn-outline-success btn-sm" (click)="bulkToggleLive(true)">
            <i class="pi pi-upload" style="margin-right:6px;"></i>
            Push All to Live
          </button>

          <button class="btn btn-outline-danger btn-sm" (click)="bulkToggleLive(false)">
            <i class="pi pi-download" style="margin-right:6px;"></i>
            Remove All from Live
          </button>
          <p-dropdown [options]="sourceOptions" [(ngModel)]="selectedSource" (onChange)="onSourceChange()"
            optionLabel="label" optionValue="value" placeholder="Select Source">
          </p-dropdown>

          <span class="p-input-icon-left">
            <input pInputText type="text" [(ngModel)]="globalSearch" (ngModelChange)="applySearch()"
              placeholder="Search" />
          </span>
        </div>
      </div>

      <!-- Segment pills only for Update BE Guidances -->
      <div class="segment-row" *ngIf="selectedSource === 'updatedbeguidance'">
        <button type="button" class="seg-btn" [class.active]="beBucket === 'newly_added'"
          (click)="onBeBucketChange('newly_added')">
          Newly Added Guidances
        </button>

        <button type="button" class="seg-btn" [class.active]="beBucket === 'newly_revised'"
          (click)="onBeBucketChange('newly_revised')">
          Newly Revised Guidances
        </button>
      </div>

      <p-table #updatesTable [value]="pagedRows" [paginator]="true" [rows]="pageSize" [first]="(page-1)*pageSize"
        [rowsPerPageOptions]="[10,50,100]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [totalRecords]="totalRecords"
        [loading]="loading" [lazy]="true" (onPage)="onPage($event)" [scrollable]="true"
        [tableStyle]="{ 'min-width': '60%' }">

        <!-- Header -->
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of uiColumns">
              <span class="header-container">{{ col.header }}</span>
            </th>
            <th><span class="header-container">Is in live</span></th>
            <th><span class="header-container">Action</span></th>
          </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-row>
          <tr>
            <td *ngFor="let col of uiColumns">
              <button *ngIf="(col.field === 'Indication_Details' || col.field === 'Old_Indication' || col.field === 'New_Indication') && row[col.field]"
                class="btn btn-sm btn-link-view" (click)="showIndication(row, col.field)">
                <i class="pi pi-eye" style="margin-right: 4px;"></i> Show More
              </button>
              <span *ngIf="col.field !== 'Indication_Details' && col.field !== 'Old_Indication' && col.field !== 'New_Indication'">
                {{ formatCell(row[col.field]) }}
              </span>
              <span *ngIf="(col.field === 'Indication_Details' || col.field === 'Old_Indication' || col.field === 'New_Indication') && !row[col.field]">
                N/A
              </span>
            </td>

            <!-- Extra column: Is in live -->
            <td>
              <p-tag [severity]="row.is_in_live ? 'success' : 'danger'" [value]="row.is_in_live ? 'Yes' : 'No'">
              </p-tag>
            </td>

            <!-- Extra column: Action -->
            <td>
              <button class="btn" [ngClass]="{
                  'btn-secondary': row.__busy,
                  'btn-success': !row.__busy && !row.is_in_live,
                  'btn-danger': !row.__busy && row.is_in_live
                }" [disabled]="row.__busy" (click)="toggleLive(row)">
                <i *ngIf="row.__busy" class="pi pi-spin pi-spinner" style="margin-right:6px;"></i>
                {{ row.is_in_live ? 'Remove from live' : 'Push to live' }}
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Optional info dialog -->
    <p-dialog header="Info" [(visible)]="infoDialog" [modal]="true" [closable]="true" class="custom-dialog">
      <div class="dialog-add">
        <div class="dialog-content">
          <p>{{ infoMessage }}</p>
        </div>
        <p-footer>
          <button type="button" pButton label="Close" class="cancel-btn" (click)="infoDialog=false"></button>
        </p-footer>
      </div>
    </p-dialog>
    <!-- Indication dialog -->
    <p-dialog [header]="indicationTitle" [(visible)]="indicationVisible" [modal]="true" [closable]="true"
      [style]="{width: '50vw'}" class="indication-dialog">
      <div class="indication-container" [innerHTML]="indicationContent"></div>
      <p-footer>
        <button type="button" pButton label="Close" class="btn-danger" (click)="indicationVisible=false"></button>
      </p-footer>
    </p-dialog>
  </div>
</div>